import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-781f7754"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "同意", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "张三 2018-4-12 20:46", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "同意", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "张三 2018-4-12 20:46", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "同意", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "张三 2018-4-12 20:46", -1))

export function render(_ctx, _cache) {
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")
  const _component_el_timeline = _resolveComponent("el-timeline")

  return (_openBlock(), _createBlock(_component_el_timeline, { style: {"width":"600px","margin":"20px auto"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_timeline_item, {
        timestamp: "2023/3/15",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_timeline_item, {
        timestamp: "2023/3/14",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_timeline_item, {
        timestamp: "2023/3/13",
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}